import { lenis } from "./smooth-scroll";
import MicroModal from "micromodal";

export default function setAnchorScroll() {
  const targets = document.querySelectorAll('a[href*="#"]');

  targets.forEach((target) => {
    target.addEventListener("click", (e) => {
      const href = target.getAttribute("href");

      if (!href.includes("#")) return;

      const url = new URL(href, location.href);

      if (url.pathname !== location.pathname) return;

      if (lenis.isLocked) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      const modalEl = target.closest(".modal");
      if (modalEl) {
        MicroModal.close(modalEl.id);
        MicroModal.onClose = () => {
          scrollToHash(url.hash);
          MicroModal.onClose = null; 
        };
      } else {
        scrollToHash(url.hash);
      }
      scrollToHash(url.hash);
    });
  });

}


function scrollToHash(hash) {
  const target = document.querySelector(hash);
  if (!target) return;

  lenis.scrollTo(target, {
    duration: 1.1,
    offset: 0,
    easing: (t) => 1 - Math.pow(1 - t, 3),
  });
}

